/**
 * Product modal
 */
	import Modal from 'bootstrap/js/dist/modal'
	import Dropdown from 'bootstrap/js/dist/dropdown'
	const { productImages, selectGalleryImage, galleryArrowState } = require('./product-images')

	const routeAddProductToCart = document.body.dataset.urlAddToCart;
	const routeUpdateCartItems = document.body.dataset.urlCartItems;

	const siteProductModal = document.querySelector('#modal-product');
	const siteProductModalContent = siteProductModal.querySelector('.modal-content');

	const siteProductModalTitle = siteProductModal.querySelector('#modal-product-title')
	const siteProductModalStockBadge = siteProductModal.querySelector('#modal-product-in-stock')
	const siteProductModalImage = siteProductModal.querySelector('#modal-product-image')
	const siteProductModalThumbs = siteProductModal.querySelector('#modal-product-thumbs')
	const siteProductModalGallery = siteProductModal.querySelector('#modal-product-gallery')
	const siteProductModalGalleryPrev = siteProductModal.querySelector('#modal-product-gallery-prev')
	const siteProductModalGalleryNext = siteProductModal.querySelector('#modal-product-gallery-next')

	const updateGalleryArrows = () => {
		if (!siteProductModalThumbs || !siteProductModalGalleryPrev || !siteProductModalGalleryNext) {
			return
		}

		const state = galleryArrowState(
			siteProductModalThumbs.scrollLeft,
			siteProductModalThumbs.clientWidth,
			siteProductModalThumbs.scrollWidth,
		)

		siteProductModalGalleryPrev.hidden = !state.prev
		siteProductModalGalleryNext.hidden = !state.next
	}

	const scrollGallery = (direction) => {
		const thumb = siteProductModalThumbs.querySelector('.modal-gallery-thumb')
		const gap = parseFloat(getComputedStyle(siteProductModalThumbs).columnGap) || 0
		const step = (thumb ? thumb.getBoundingClientRect().width : 72) + gap

		siteProductModalThumbs.scrollBy({ left: direction * step, behavior: 'smooth' })
	}

	const clearProductThumbs = () => {
		if (!siteProductModalThumbs) {
			return
		}

		siteProductModalThumbs.innerHTML = ''
		siteProductModalThumbs.scrollLeft = 0
		if (siteProductModalGallery) {
			siteProductModalGallery.classList.add('d-none')
		}
		updateGalleryArrows()
	}

	const renderProductThumbs = (images) => {
		clearProductThumbs()

		if (!siteProductModalThumbs || !siteProductModalGallery || images.length < 2) {
			return
		}

		siteProductModalGallery.classList.remove('d-none')

		images.forEach((url, index) => {
			const button = document.createElement('button')
			button.type = 'button'
			button.className = 'modal-gallery-thumb' + (index === 0 ? ' is-active' : '')

			const image = document.createElement('img')
			image.src = url
			image.alt = ''
			button.appendChild(image)

			button.addEventListener('click', () => {
				const next = selectGalleryImage(siteProductModalImage.src, url)

				if (next.visible) {
					siteProductModalImage.classList.add('show')
				} else {
					siteProductModalImage.classList.remove('show')
					siteProductModalImage.src = next.src
				}

				siteProductModalThumbs.querySelectorAll('.is-active').forEach(el => el.classList.remove('is-active'))
				button.classList.add('is-active')
			})

			siteProductModalThumbs.appendChild(button)
		})

		window.requestAnimationFrame(updateGalleryArrows)
	}

	if (siteProductModalThumbs) {
		siteProductModalThumbs.addEventListener('scroll', updateGalleryArrows, { passive: true })
	}

	if (siteProductModalGalleryPrev) {
		siteProductModalGalleryPrev.addEventListener('click', () => scrollGallery(-1))
	}

	if (siteProductModalGalleryNext) {
		siteProductModalGalleryNext.addEventListener('click', () => scrollGallery(1))
	}

	if (window.ResizeObserver && siteProductModalThumbs) {
		new ResizeObserver(updateGalleryArrows).observe(siteProductModalThumbs)
	}

	const siteProductModalDescription = siteProductModal.querySelector('#modal-product-description')
	const siteProductModalQuantity = siteProductModal.querySelector('#modal-product-quantity')
	const siteProductModalId = siteProductModal.querySelector('#modal-product-id')
	const siteProductModalPriceBefore = siteProductModal.querySelector('#modal-product-price-before')
	const siteProductModalPriceOffer = siteProductModal.querySelector('#modal-product-price-offer')

	const siteModalAddProductToCart = document.querySelector('[site-cart-add-modal]');

	siteProductModal.addEventListener('show.bs.modal', e => {
		window.axios.get(e.relatedTarget.href)
			.then(res => {
				const data = res.data;
				const images = productImages(data);
				const cartProduct = { ...data };
				delete cartProduct.gallery;

				siteModalAddProductToCart.dataset.product = JSON.stringify(cartProduct);

				siteProductModalTitle.innerHTML = data.name
				siteProductModalImage.src = images[0] || ''
				renderProductThumbs(images)
				siteProductModalId.value = data.id
				siteProductModalQuantity.value = '1';

				const currentPrice = data.price ? data.price : data.value;

				siteProductModalPriceOffer.innerHTML =  Intl.NumberFormat('pt-BR', {
					style: 'currency',
					currency: 'BRL',
				}).format((currentPrice));

				if (data.price) {
					siteProductModalPriceBefore.innerHTML = Intl.NumberFormat('pt-BR', {
						style: 'currency',
						currency: 'BRL',
					}).format((data.value));

					siteProductModalPriceBefore.classList = 'd-block'
				}

				if (data.description) {
					siteProductModalDescription.innerHTML = data.description
					siteProductModalDescription.classList = 'd-block'
				}

				if (data.inStock > 0) {
					siteProductModalStockBadge.classList.remove('d-none')
				}

			})
			.then(_ => {
				siteProductModalContent.classList.add('show')
				siteProductModalImage.addEventListener('load', _ => siteProductModalImage.classList.add('show'))

				const modal = Modal.getOrCreateInstance('#modal-product');
				modal.handleUpdate();
				updateGalleryArrows()
			})
			.catch(err => {
				siteAlertFromAxiosError(err, 'Não foi possível carregar o produto.');
				console.error(err)
			})
	});


	siteProductModal.addEventListener('hidden.bs.modal', e => {
		siteProductModalContent.classList.remove('show')
		siteProductModalImage.classList.remove('show')

		siteProductModalTitle.innerHTML = ''
		siteProductModalImage.src = ''
		clearProductThumbs()
		siteProductModalDescription.innerHTML = ''
		siteProductModalDescription.classList = 'd-none'
		siteProductModalId.value = ''
		siteProductModalQuantity.value = '1'
		siteProductModalPriceOffer.innerHTML = ''
		siteProductModalPriceBefore.classList = 'd-none'
		siteProductModalStockBadge.classList.add('d-none')
	})

/**
 * Modal quantity control
 */
	const siteLess = document.querySelectorAll('[site-product-less]')
	const siteMore = document.querySelectorAll('[site-product-more]')

	// less
	if (siteLess.length > 0) {
		siteLess.forEach(e => {
			const input = e.parentElement.querySelector('input')
			e.addEventListener('click', _ => {
				if (input.value != 1) input.value = parseInt(input.value) - 1
			})
		})
	}

	// more
	if (siteMore.length > 0) {
		siteMore.forEach(e => {
			const input = e.parentElement.querySelector('input')
			e.addEventListener('click', _ => {
				input.value = parseInt(input.value) + 1
			})
		})
	}


	/* ------ */


/**
 * ADD TO CART
 */
	const siteCartButton = document.querySelector('.cart')

	const siteCartSum = (initialRequest = false) => {

		const itemsElement = siteCartButton.querySelector('b')

		if(!itemsElement) {
			return;
		}

		window.axios.put(routeUpdateCartItems).then(res => {
			siteCartButton.classList.add('has--products');

			if(!initialRequest) {
				siteAlert({
					class: 'alert--i_success',
					text: 'Produto adicionado na sacola!'
				});
			}

			const siteCartSize = res.data.items;
			itemsElement.innerHTML = siteCartSize

			if (siteCartSize == 1) {
				siteCartButton.querySelector('span').innerHTML = '01 produto'
			} else if (siteCartSize > 1 && siteCartSize < 10) {
				siteCartButton.querySelector('span').innerHTML = '0' + siteCartSize + ' produtos'
			} else if (siteCartSize >= 10) {
				siteCartButton.querySelector('span').innerHTML = siteCartSize + ' produtos'
			} else {
				siteCartButton.querySelector('span').innerHTML = 'sacola vazia'
			}
		});

	}

	/**
	 * Add product from list
	*/
		const siteCartAdd = document.querySelectorAll('[site-cart-add-single]')

		if (siteCartAdd.length > 0) {
			siteCartAdd.forEach(e => {
				e.addEventListener('click', e => {

					const data = JSON.parse(e.currentTarget.dataset.product);
					data.quantity = siteModalProductQuantity.value;

					window.axios.post(routeAddProductToCart, data)
							.then(_ => {
								siteCartSum();
							})
							.catch(err => {
								siteAlertFromAxiosError(err, 'Não foi possível adicionar o produto.');
							});
				})
			})
		}

	/**
	 * Add product from modal
	 */
		const siteCartAddModal = document.querySelectorAll('[site-cart-add-modal]');
		const siteModalProductQuantity = document.querySelector('[site-product-quantity]');

		if (siteModalProductQuantity.value > 0) {
			siteCartAddModal.forEach(e => {
				e.addEventListener('click', e => {
					e.preventDefault()

					const { product } = e.currentTarget.dataset;

					const data = JSON.parse(product);
					data.quantity = siteModalProductQuantity.value;
					window.axios.post(routeAddProductToCart, data)
						.then(_ => {
							siteCartSum();
							document.querySelector('.modal-header button').click();
						})
						.catch(err => {
							siteAlertFromAxiosError(err, 'Não foi possível adicionar o produto.');
						});
				})
			})
		}

		siteCartSum(true);
